module.exports = __webpack_public_path__ + "img/vertical_3_2_8004.14353ba0.png";